import setSentryContext from './setSentryContext';

export default function captureSentryException(exception, extras = null) {
  const sentryEnabled = process.env.SENTRY_ENABLED === 'true';
  if (!sentryEnabled) { return; }

  setSentryContext();

  if (extras !== null) {
    window.Sentry.withScope((scope) => {
      Object.entries(extras).forEach(([key, value]) => {
        scope.setExtra(key, value);
      });
      Sentry.captureException(exception);
    });
  } else {
    Sentry.captureException(exception);
  }
}
